import React from 'react';
import { FormattedMessage } from 'react-intl';
import SwitchLangButton from './SwitchLangButton';

const SupportText: React.FC<{
  selectedLang: string;
  changeLang: (locale: string) => void;
}> = ({ selectedLang, changeLang }) => (
  <div
    css={`
      text-align: center;
      color: ${(props) => props.theme.gray};
      padding: 16px 0;
      margin: 24px 0 0;
      font-size: 12px;
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 8px;
      font-family: ${(props) => props.theme.fontFamily};
    `}
  >
    <FormattedMessage defaultMessage="Can we help you? Call our support at +49 30 208 98 63 30" />
    <SwitchLangButton selectedLang={selectedLang} changeLang={changeLang} />
  </div>
);

export default SupportText;
